import { API } from '@Providers';

interface AdoptionFeePayload {
  adoption_fee: string;
  animal_id: string;
}

export default async function (payload: AdoptionFeePayload) {
  const endpoint = '/api/shelter/animal/update-cart-animal-adoption-fee';

  return API({ endpoint, method: 'put', payload });
}
